import {Logger} from "./Logger";

export function AdblockPlugin(adResourceUrl) {
  let _logger = Logger();
  let _trackerInstance;
  let adBlockerDetected = false;

  function detectAdBlocker() {
    const enrichRequest = new XMLHttpRequest();
    enrichRequest.addEventListener("error", function () {
      _logger.debug('ad blocker detected');
      adBlockerDetected = true;
    });
    //try to get a resource that is blacklisted in https://easylist.to/easylist/easylist.txt
    //can be relative or absolute URL
    enrichRequest.open("GET", adResourceUrl);
    enrichRequest.send();
  }

  //implementation for methods from Snowplow BrowserPlugin interface
  return {
    activateBrowserPlugin: (tracker) => {
      _trackerInstance = tracker;
      _logger.debug("AdblockPlugin activated on sp instance id and namespace ", tracker.id, tracker.namespace);
      detectAdBlocker();
    },
    beforeTrack: (payloadBuilder) => {
      const payload = payloadBuilder.getPayload();
      _logger.debug("before track payload", payload);
      if (payload["e"] === "pv") {
        payloadBuilder.addContextEntity({"schema": "iglu:be.investdata.adblocker/adblock_detection/jsonschema/1-0-0", "data": {"adBlockerDetected": adBlockerDetected}});
      }
    },
    logger: (logger) => _logger = logger
  }
}
